import InsuranceFamily, {IInsuranceFamily} from "@/model/InsuranceFamily/InsuranceFamily"

export interface IGlobalInsuranceFamily extends IInsuranceFamily {

}

class GlobalInsuranceFamily extends InsuranceFamily implements IGlobalInsuranceFamily {

    constructor(id: string) {
        super(id)
    }
}

export default GlobalInsuranceFamily